import { useState } from 'react'
import { Box, ClickAwayListener, Divider, Paper, Typography } from '@material-ui/core'
import _ from 'lodash'
import MuiAlert from '@material-ui/lab/Alert'
import Snackbar from '@material-ui/core/Snackbar'
import DownArrow from '../../svgs/downarrow'
import EnphaseLogo from '../../images/enphase.png'
import UserLogo from '../../svgs/userlogo'
import history from '../../routes/history'
import axios from 'axios'
import urlStrings from '../../utils/urlStrings'
import { userService } from '../../Services/UserService'
import { ENPHASE_INSTALLER, CUSTOMER_SUPPORT } from './constants'
import {
  getSessionToken,
  getUserName,
  getIsInstaller,
  clearSessionValues,
  getSessionId,
} from '../../utils/helper'

import { useStyles } from './styles'
function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />
}

const Header = (props) => {
  const { setLoading, selected, setSelected } = props
  const classes = useStyles()
  const [openBodySnackBar, setOpenBodySnackBar] = useState(false)
  // const [selected, setSelected] = useState(false)
  const handleBodySnackBarClose = () => {
    setOpenBodySnackBar(false)
  }
  return (
    <div className={classes.header}>
      <Box className={classes.left}>
        <img src={EnphaseLogo}></img>
        <div className={classes.leftText}>
          <Typography className={classes.leftTextStyle}>
            Battery Bonus Program
          </Typography>
          <Divider
            orientation="vertical"
            flexItem="true"
            classes={{ root: classes.root }}
          ></Divider>
          <Typography className={classes.leftTextStyle}>
            Validation Portal
          </Typography>
        </div>
      </Box>
      {_.isEmpty(getSessionToken()) === false ? (
        <Box className={classes.right}>
          <UserLogo></UserLogo>
          <Typography style={{ marginLeft: '10px' }}>
            Hi {getUserName()}
          </Typography>
          <DownArrow
            style={{ cursor: 'pointer', marginLeft: '10px' }}
            onClick={() => {
              setSelected(!selected)
            }}
          ></DownArrow>
        </Box>
      ) : (
        <></>
      )}
      {selected ? (
        <ClickAwayListener onClickAway={() => setSelected(false)}>
          <Paper elevation="2" className={classes.useroptions}>
            {getIsInstaller() === 'true' ? (
              <Box className={classes.useroption}>
                <Typography className={classes.text}>
                  <a
                    href="mailto:gridservices@enphase.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: 'none', color: 'inherit' }}
                  >
                    Contact Support
                </a>
                </Typography>
              </Box>
            ) : null}
            <Box
              className={classes.useroption}
              onClick={() => {
                setLoading(true)
                userService.logoutUser()
                  .then((success) => {
                    clearSessionValues()
                    setLoading(false)
                    setOpenBodySnackBar(true)
                    clearSessionValues()
                    history.push('/')
                  })
                  .catch((error) => {
                    setOpenBodySnackBar(true)
                    setLoading(false)
                  })
              }}
            >
              <Typography className={classes.text}>Log Out</Typography>
            </Box>
          </Paper>
        </ClickAwayListener>
      ) : null}
      {openBodySnackBar ? (
        getSessionId() ? (
          <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            open={openBodySnackBar}
            onClose={handleBodySnackBarClose}
            key={'top' + 'center'}
          >
            <Alert onClose={handleBodySnackBarClose} severity="error">
              Log out unsuccessful!
            </Alert>
          </Snackbar>
        ) : (
          <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            open={openBodySnackBar}
            onClose={handleBodySnackBarClose}
            key={'top' + 'center'}
          >
            <Alert onClose={handleBodySnackBarClose} severity="success">
              Logged out successfully!
            </Alert>
          </Snackbar>
        )
      ) : null}
    </div>
  )
}
export default Header
